import { mapActions } from 'vuex'
export default {
	data: () => ({
		dialog: false,
		fullscreen: false,
		loading: false,

		rules: {
			required: (value) => !!value || "Обов'язкове для заповнення",
			onlyFromList: (v) => (!!v && v?.id > 0 ) || "Необхідно обрати значення зі списку",
		},
		
		/* title: 'role',
		icon: 'mdi-account-tie', */
	}),
	props: {
		value:						{ type: Object, default: () => {} },
		//modelValue:					{ type: Object, default: () => {} },
		tooltip:  					{ type: String, default: 'edit' },

		//selected: 					{ type: Object, default: null },
	},

	computed: {
		selected: {
			get() 		{ return this.value },
			set(val) 	{ this.$emit('input', val) }
		},
		/* selected: {
			get() 		{ return this.modelValue },
			set(val) 	{ this.$emit('update:modelValue', val) }
		}, */
	},

	watch: {
		dialog: function (val) {
			if(val) {
				this.onOpen()
			} else {
				this.onClose()
			}
		},
	},

	methods: {
		...mapActions([ 'showMessage' ]),

		addItems (items, data) {
			for(let i in data) {
				items.push(data[i]);
			}
		},

		removeItem (items, item) {
			const index = items.indexOf(item)
			items.splice(index, 1);
		},

		removeItems(items, filtered, indexes) {
			let itms = []
			indexes.forEach((i) => itms.push(filtered[i]));
			itms.forEach((item) => this.removeItem(items, item));
		},

		onOpen () {
			//console.log('details.mixin.main', 'onOpen','selected', this.selected)

			this.find(this.selected)
		},

		onClose () {
			//this.setItem()
		},

		onCancel () {
			this.dialog = false
		},

		onOK () {
			//var that = this
			//this.loading = true

			/* let promise = this.item.id ? this.update() : this.create()
			promise.then(response => {
				//console.log('Roles', 'load','response.data', response.data)
				that.item = response.data

				that.loading 	= false
				this.dialog 	= false

				//that.showMessage({text: 'OK', status: '200'})
			}, error => {
				//console.log(error)
				that.loading = false
				that.showMessage(error)
			}) */
		},
	},
}